import * as React from "react";

import BaseSvg from "../BaseSvg";

import SvgComponent from "./svgFile";

export default function GenericAvatar(props) {
  return <BaseSvg renderComponent={SvgComponent} {...props} />;
}
